import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Heading2 } from '../../ui/Typography/Heading';
import { Input } from '../../ui';
import { updateConfigOnboardingSettings } from '../../../redux/config/slice';
import { OnboardingNavbar } from '../OnboardingNavbar/OnboardingNavbar';
import { OnboardingProgress } from '../OnboardingProgress/OnboardingProgress';
import { OnboardingActions } from '../OnboardingActions/OnboardingActions';
import { selectUpdateConfigLoading } from '../../../redux/config/selectors';
import { createHousingStock, updateHousingStock, getHousingStocks } from '../../../redux/housingStocks/slice';
import { selectHousingStocks } from '../../../redux/housingStocks/selectors';
import { ONBOARDING_STEPS } from '../../../consts/consts';
import {
  OnboardingHeaderGroup,
  OnboardingContent,
  OnboardingContentGroup,
  OnboardingContentTitle,
  OnboardingStepWrapper,
  OnboardingFieldWrapper,
  OnboardingFieldErrorText,
  OnboardingFieldLabel
} from '../../ui/Layout/OnboardingLayout';

export const OnboardingStepHousingStockComponent = ({
  updateConfigOnboardingSettings,
  createHousingStock,
  updateHousingStock,
  getHousingStocks,
  updateConfigLoading,
  housingStocks
}) => {
  const [name, setName] = useState('');
  const [initialName, setInitialName] = useState('');
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    getHousingStocks();
  }, [getHousingStocks]);

  useEffect(() => {
    if (housingStocks && housingStocks.length > 0) {
      const stockName = housingStocks[0].name || '';
      setName(stockName);
      setInitialName(stockName);
    }
  }, [housingStocks]);

  const getErrorMessage = () => {
    if (!touched) return '';
    if (!name.trim()) return '↑ Pflichtfeld';
    return '';
  };

  const errorMessage = getErrorMessage();

  const handleNext = () => {
    setTouched(true);
    if (!name.trim()) return;

    const nextStepCallback = () => updateConfigOnboardingSettings({ step: ONBOARDING_STEPS.PARTNERS });

    if (name === initialName) {
      nextStepCallback();
      return;
    }

    if (housingStocks && housingStocks.length > 0) {
      updateHousingStock({
        housingStock: { ...housingStocks[0], name },
        callback: nextStepCallback
      });
    } else {
      createHousingStock({
        housingStock: { name },
        callback: nextStepCallback,
        showSuccessNotification: false
      });
    }
  };

  return (
    <>
      <OnboardingNavbar loading={updateConfigLoading} />
      <OnboardingProgress />
      <OnboardingContent className="step-housing-stock">
        <OnboardingStepWrapper>
          <OnboardingHeaderGroup>
            <OnboardingContentTitle>
              <Heading2>Angaben zu Ihrem Bestand</Heading2>
            </OnboardingContentTitle>
          </OnboardingHeaderGroup>

          <OnboardingContentGroup className="step-housing-stock content">
            <OnboardingFieldLabel>Name des Bestandes</OnboardingFieldLabel>
            <OnboardingFieldWrapper>
              <Input
                value={name}
                onChange={(e) => setName(e.target.value)}
                onBlur={() => setTouched(true)}
                status={errorMessage ? 'error' : undefined}
              />
              {errorMessage && <OnboardingFieldErrorText>{errorMessage}</OnboardingFieldErrorText>}
            </OnboardingFieldWrapper>
          </OnboardingContentGroup>
        </OnboardingStepWrapper>
        <OnboardingActions onNext={handleNext} loading={updateConfigLoading} />
      </OnboardingContent>
    </>
  );
};

const mapStateToProps = (state) => ({
  updateConfigLoading: selectUpdateConfigLoading(state),
  housingStocks: selectHousingStocks(state)
});

const mapDispatchToProps = {
  updateConfigOnboardingSettings,
  createHousingStock,
  updateHousingStock,
  getHousingStocks
};

export const OnboardingStepHousingStock = connect(
  mapStateToProps,
  mapDispatchToProps
)(OnboardingStepHousingStockComponent);
